// extracted by mini-css-extract-plugin
export var borderRadius = "_gw-4";
export var large = "_gw-3";
export var logoContainer = "_gw-0";
export var nameLogo = "_gw-2";
export var small = "_gw-1";